import * as React from "react";
import { Marker, Polyline } from "@react-google-maps/api";

type MeasureApi = {
  measuring: boolean;
  measurePoints: google.maps.LatLngLiteral[];
  setMeasurePoints: React.Dispatch<
    React.SetStateAction<google.maps.LatLngLiteral[]>
  >;
  measureClosed: boolean;
  setMeasureClosed: React.Dispatch<React.SetStateAction<boolean>>;
  measureSessionId: number;
  measurePolylineRef: React.MutableRefObject<google.maps.Polyline | null>;
  measureOverlaysRef: React.MutableRefObject<Array<google.maps.MVCObject>>;
};

export function MeasuringLayer({ measure }: { measure: MeasureApi }) {
  const {
    measurePoints,
    measureSessionId,
    measurePolylineRef,
    measureOverlaysRef,
  } = measure;

  if (measurePoints.length === 0) return null;

  const hasPoints = measurePoints.length > 0;
  const hasLine = measurePoints.length > 1;

  if (!hasPoints) return null;

  return (
    <>
      {/* startingpoint */}
      {hasPoints && (
        <Marker
          key={`measure-start-${measureSessionId}`}
          position={measurePoints[0]}
          icon={{
            path: "M 0 0 m -8, 0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0",
            fillColor: "#E10E1C",
            fillOpacity: 1,
            strokeColor: "#fff",
            strokeWeight: 2,
            scale: 1,
          }}
          onLoad={(m) => measureOverlaysRef.current.push(m)}
          onUnmount={(m) => m.setMap(null)}
        />
      )}

      {/* stoppoint */}
      {hasLine && (
        <Marker
          key={`measure-end-${measureSessionId}`}
          position={measurePoints[measurePoints.length - 1]}
          icon={{
            path: "M 0 0 m -8, 0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0",
            fillColor: "#E10E1C",
            fillOpacity: 1,
            strokeColor: "#fff",
            strokeWeight: 2,
            scale: 1,
          }}
          onLoad={(m) => measureOverlaysRef.current.push(m)}
          onUnmount={(m) => m.setMap(null)}
        />
      )}

      {/* line between points */}
      {hasLine && (
        <Polyline
          key={`measure-poly-${measureSessionId}`}
          path={measurePoints}
          options={{
            strokeColor: "#E10E1C",
            strokeOpacity: 1,
            strokeWeight: 4,
            geodesic: true,
          }}
          onLoad={(poly) => {
            measurePolylineRef.current = poly;
            measureOverlaysRef.current.push(poly);
          }}
          onUnmount={(poly) => {
            try {
              poly.getPath()?.clear();
            } catch {}
            poly.setMap(null);
            if (measurePolylineRef.current === poly) {
              measurePolylineRef.current = null;
            }
          }}
        />
      )}
    </>
  );
}
